var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vg-view-field',_vm._g(_vm._b({attrs:{"label":_vm.label,"value":_vm._f("enumText")(_vm.value,_vm.constructionType)}},'vg-view-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }